import { render, staticRenderFns } from "./CollectionList.vue?vue&type=template&id=dc633536&scoped=true"
import script from "./CollectionList.vue?vue&type=script&lang=js"
export * from "./CollectionList.vue?vue&type=script&lang=js"
import style0 from "./CollectionList.vue?vue&type=style&index=0&id=dc633536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc633536",
  null
  
)

export default component.exports